module.exports = __webpack_public_path__ + "img/hello-lighting.6a3eeb51.png";